import { OPEN_MODAL } from 'app/modal/actions/index';

const openModal = (component, props) => ({
  type: OPEN_MODAL,
  props,
  component,
});

export default openModal;
